import React from 'react';
import PropTypes from 'prop-types';
import { styled, Grid, Row, Col } from '@smooth-ui/core-sc';

const ClipedBg = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 0;
  width: 100%;

  @media (min-width: 1600px) {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 15% 100%);
    padding: 15px;
  }
`;

const BgGradient = ({ children, className }) => {
  return (
    <ClipedBg className={`${className} gradient`}>
      <Grid>
        <Row justifyContent="center">
          <Col xs={12}>{children}</Col>
        </Row>
      </Grid>
    </ClipedBg>
  );
};

BgGradient.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
};

BgGradient.defaultProps = {
  children: null,
  className: '',
};

export default BgGradient;
